import { Component, OnInit } from '@angular/core';
import { RcmGridColumnDetails, RcmQuoteGridData } from '@app/rcm/rcm-data-table/rcm-data-table/rcm-data-table.component';
import { LoadingService } from '@app/shared/services/loading/loading.service';
import { SharedService } from '@app/shared/services/shared.service';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'aar-quote-management',
  templateUrl: './quote-management.component.html',
  styleUrls: ['./quote-management.component.scss']
})
export class QuoteManagementComponent implements OnInit {

  private searchKeyword = '';
  private externalSubscriptions = new Subscription();
  private rcmGridOrders: RcmQuoteGridData[] = [];

  rcmGridOrdersFiltered: RcmQuoteGridData[] = [];
  columnsSettings: RcmGridColumnDetails[] = [];

  constructor(
    private sharedService: SharedService,
    private loadingService: LoadingService

  ) { }

  ngOnInit(): void {

    this.subscribeToKeywordSearch();
    this.buildData();
    this.setGridHeaders();
    this.filterByKeyWord();
  }

  private buildData(): void {
    this.rcmGridOrders = [{
      id: 8075,
      repairOrderId: 1212,
      repairOrderNumber: '4521687-1',
      repairOrderLineId: 8075,
      quotedPartNumber: '232',
      quotedSerialNumber: '444',
      quotedWorkscope: 'Repair',
      totalSupplierValue: '100',
      currency: 'USD',
      supplier: 'Supplier 2',
      user: 'User 1',
      originalQuoteProcessedDate: '01Jan25',
      quoteDaysElapsed: 23,
      lastActionDate: '01Jan25',
      lastActionUserId: 2,
      paperClipImage: '',
      documents: ''
    }, {
      id: 8075,
      repairOrderId: 1212,
      repairOrderNumber: '4521688-1',
      repairOrderLineId: 8076,
      quotedPartNumber: '5355',
      quotedSerialNumber: '35355',
      quotedWorkscope: 'Overhaul',
      totalSupplierValue: '500',
      currency: 'USD',
      supplier: 'Supplier 1',
      user: 'User 2',
      originalQuoteProcessedDate: '01Feb25',
      quoteDaysElapsed: 13,
      lastActionDate: '01Feb25',
      lastActionUserId: 2,
      paperClipImage: '',
      documents: ''
    }] as RcmQuoteGridData[]
  }

  private setGridHeaders(): void {
    this.columnsSettings = [
      { name: 'repairOrderNumber', label: 'Repair Order', filterable: true, exportable: true, showInGrid: true },
      { name: 'quotedPartNumber', label: 'Quoted Part Number', filterable: true, exportable: true, showInGrid: true },
      { name: 'quotedSerialNumber', label: 'Quoted Serial Number', filterable: true, exportable: true, showInGrid: true },
      { name: 'quotedWorkscope', label: 'Quoted Workscope', filterable: true, exportable: true, showInGrid: true },
      { name: 'totalSupplierValue', label: 'Total Supplier Value', filterable: true, exportable: true, showInGrid: true },
      { name: 'currency', label: 'Currency', filterable: true, exportable: true, showInGrid: true },
      { name: 'supplier', label: 'Supplier', filterable: true, exportable: true, showInGrid: true },
      { name: 'user', label: 'User', filterable: true, exportable: true, showInGrid: true },
      { name: 'originalQuoteProcessedDate', label: 'Original Quote Processed Date', filterable: true, exportable: true, showInGrid: true },
      { name: 'quoteDaysElapsed', label: 'Quote Days Elapsed', filterable: true, exportable: true, showInGrid: true },
      { name: 'lastActionDate', label: 'Last Action Date', filterable: true, exportable: true, showInGrid: true },
      { name: 'lastActionUserId', label: 'Last Action User ID', filterable: true, exportable: true, showInGrid: true },
      { name: 'documents', label: 'Documents', filterable: true, exportable: true, showInGrid: true },
      { name: 'repairOrderLineId', label: 'RepairOrderLineId', filterable: true, exportable: false, showInGrid: false }
    ];
  }

  private filterByKeyWord() {
    const message = this.searchKeyword.toLowerCase() || '';
    let filteredOrders = this.rcmGridOrders.filter(
      (x) =>
        (x.repairOrderNumber &&
          x.repairOrderNumber.toLowerCase().includes(message)) ||
        (x.quotedPartNumber &&
          x.quotedPartNumber.toLowerCase().includes(message)) ||
        (x.currency &&
          x.currency.toLowerCase().includes(message)) ||
        (x.quotedSerialNumber &&
          x.quotedSerialNumber.toLowerCase().includes(message)) ||
        (x.quotedWorkscope &&
          x.quotedWorkscope.toLowerCase().includes(message)) ||
        (x.quoteDaysElapsed &&
          x.quoteDaysElapsed.toString().includes(message)) ||
        (x.supplier &&
          x.supplier.toLowerCase().includes(message)) ||
        (x.totalSupplierValue &&
          x.totalSupplierValue.includes(message))
    );

    this.buildGridData(filteredOrders);

  }

  private buildGridData(orders: RcmQuoteGridData[]) {

    this.rcmGridOrdersFiltered = orders.map((order: RcmQuoteGridData) => ({
      repairOrderId: order.repairOrderId,
      repairOrderNumber: order.repairOrderNumber,
      supplier: order.supplier,
      quotedPartNumber: order.quotedPartNumber,
      repairOrderLineId: order.repairOrderLineId,
      quotedSerialNumber: order.quotedSerialNumber,
      quotedWorkscope: order.quotedWorkscope,
      totalSupplierValue: order.totalSupplierValue,
      currency: order.currency,
      user: order.user,
      originalQuoteProcessedDate: order.originalQuoteProcessedDate,
      quoteDaysElapsed: order.quoteDaysElapsed,
      lastActionDate: order.lastActionDate,
      lastActionUserId: order.lastActionUserId,
      documents: order.documents,
      paperClipImage: 'assets/images/fpo/suppliers/paperclip.png'
    } as RcmQuoteGridData));

  }

  private subscribeToKeywordSearch() {

    this.externalSubscriptions.add(this.sharedService.getSearchKeyWord()
      .pipe(tap(() => this.loadingService.startLoading()))
      .subscribe((message) => {
        this.searchKeyword = message;
        this.loadingService.stopLoading();
        this.filterByKeyWord();
      }, err => {
        this.loadingService.stopLoading();
      }));
  }
}